/*
Sohel 10/26/2022 3031450488 Integrated Filter API.
Sohel 10/27/2022 3031450488 Integrated Field List and Filter Save API.
Saikrishna 27/10/2022 3075234474 Scheduling save API Integrated.
Sohel 10/27/2022 3031450488 Integrated get API.
Sohel 10/27/2022 2701375033 Integrated Copy Functionality API.
Saikrishna 10/28/2022 3031450488 Integrated save and get apis for report fields section step 4
akhila 10/29/2022 3031450488  Additional Info save api
Sohel 10/29/2022 3031450488 Integrated get All reportCode API.
Saikrishna 29/10/2022 3031450488 Reset status fo report fields and 5th step updating redux commented for stopping page crash
Sohel 10/30/2022 3031450488 reset Additional info and Report field staus.
Saikrishna 11/01/2022 3031450488 Added redux state for fixedlength for report fields
Sohel 11/01/2022 3031450488 reset get values.
Sohel 11/04/2022 3031450488 reset schedule get values.
saikrishna 11/11/2022 3031450488 fixed length redux state updated
saikrishna 11/25/2022  3031450488 Added BasicInof new Ui fields
Sohel 11/25/2022  3031450488 Added Filters new API changes
akhila 11/26/2022 3031450488 integrated username api.
akhila 1/12/2022 3031450488 integrated workqueue post and get api
Saikrishna 12/01/2022 3031450488 Conditionally called get api after save filter API.
Saikrishna 12/02/2022 3031450488 execution done.
akhila 12/2/2022 3031450488 integrated copy api for workqueues
Dilip 12/05/2022  3031450488 Removed unecesarry console.log statements
Ashraf 12/07/2022 3031450488 fixed userName page break issue
Ashraf 12/07/2022 3031450488 mapped userName for dropdown values
Rajesh 12/14/2022 303145048 added reset for executions
Ashraf 12/19/2022 303145048 commented data modification for get username results
Sai Maheshwar 12/12/2022 3031450488 fixed last step reset issue
Dilip 02/09/2023 3031450488 integrated craetedFor api
Sohel 22/05/2023 3031450488 Fixed Created For Issue
Akhila 06/21/2023 3031450488 conditionally disable save and finish button on submission
Ravi 06/24/2023 3031450488  removed type from basicInfo get API
*/
import { createSlice } from '@reduxjs/toolkit';
import { httpPost } from '../../../util/Rest';
import { httpGet } from './../../../util/Rest';
import _ from 'lodash';
import { submissionEnd } from '../CommonActions/commonActions';

const initialState = {
  successMsg: null,
  errorMsg: null,
  isLoading: false,
  addHeaderStatus: null,
  addScheduleStatus: null,
  addAdditionalInfoStatus: null,
  addWorkQueueStatus: null,
  filterData: [],
  executionData: [],
  reportCode: '',
  reportName: '',
  addFilterStatus: null,
  addFieldListStatus: null,
  reportFieldsPostStatus: null,
  reportMasterData: {},
  reportFieldsData: [],
  ScheduleData: {},
  reportFieldsSortData: [],
  reportDateStampFields: [],
  basicInfoData: {},
  fieldlListData: {},
  additionalInfoData: {},
  WorkQueueData: {},
  getfilterData: {},
  copyReportStatus: null,
  copyWorkQueueStatus: null,
  iscopyLoading: false,
  copySuccessMsg: null,
  copyErrorMsg: null,
  actionData: [],
  reportCodeData: [],
  reportCreatedForData: [],
  fixedlength: '',
  isDraftReport: 'Y',
  isWorkqueueAddClicked: false,
  initialSave: false,
  lastStep: 0,
  createdByData: [],
  createdForData: [],
  workQueueNameAllData: [],
};

const addReportMaster = createSlice({
  name: 'addReport',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchCopy: (state) => {
      state.iscopyLoading = true;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    fetchCopyError: (state, action) => {
      state.copyErrorMsg = action.payload;
      state.iscopyLoading = false;
    },
    postHeaderData: (state, action) => {
      state.addHeaderStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.reportCode = action.payload?.response?.reportId;
      state.fixedlength = action.payload?.response?.fixedLength;
      state.reportName = action.payload?.response?.reportCode;
    },
    postFilterData: (state, action) => {
      state.addFilterStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.reportCode = action.payload.response.reportId;
      state.reportName = action.payload?.response?.reportCode;
    },
    postFieldListData: (state, action) => {
      state.addFieldListStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    postScheduleData: (state, action) => {
      state.addScheduleStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    getReportMasterData: (state, action) => {
      state.reportMasterData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getReportFieldsData: (state, action) => {
      state.reportFieldsData = action.payload?.reportFields;
      state.reportFieldsSortData = action.payload?.reportsortFields;
      state.reportDateStampFields = action.payload?.reportDateStampFields;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getReportCodeData: (state, action) => {
      state.reportCodeData = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getWorkQueueNameData: (state, action) => {
      state.workQueueNameAllData = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getCreatedByData: (state, action) => {
      state.createdByData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getCreatedForData: (state, action) => {
      state.createdForData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },

    getReportCreatedForData: (state, action) => {
      state.reportCreatedForData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getScheduleData: (state, action) => {
      state.ScheduleData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getFieldListData: (state, action) => {
      state.fieldlListData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postReportFieldsData: (state, action) => {
      state.reportFieldsPostStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.reportCode = action?.payload?.response?.length
        ? action.payload.response[0].reportId
        : '';
      state.reportName = action?.payload?.response?.length
        ? action.payload.response[0].reportCode
        : '';
    },
    getAdditionalInfoData: (state, action) => {
      state.additionalInfoData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getWorkQueueData: (state, action) => {
      state.WorkQueueData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    postAdditionalInfoData: (state, action) => {
      state.addAdditionalInfoStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    postWorkQueueData: (state, action) => {
      state.addWorkQueueStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    getFilterData: (state, action) => {
      state.filterData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getRunExecutionData: (state, action) => {
      state.executionData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getFilterDatas: (state, action) => {
      state.getfilterData = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getBasicInfoData: (state, action) => {
      state.basicInfoData = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.reportName = action?.payload?.response?.reportCode;
    },
    setReduxState: (state, action) => {
      state[action.payload.property] = action?.payload?.value;
    },
    postCopyReportData: (state, action) => {
      state.copyReportStatus = action.payload?.status;
      state.iscopyLoading = false;
      state.copySuccessMsg = action.payload?.message;
      state.copyErrorMsg = null;
      state.copyCode = action.payload?.response?.reportId;
      state.reportCode = action.payload?.response?.reportId;
      state.reportName = action.payload?.response?.reportCode;
    },
    postCopyWorkQueueData: (state, action) => {
      state.copyWorkQueueStatus = action.payload?.status;
      state.iscopyLoading = false;
      state.copySuccessMsg = action.payload?.message;
      state.copyErrorMsg = null;
      state.copyCode = action.payload?.response?.reportId;
      state.reportCode = action.payload?.response?.reportId;
      state.reportName = action.payload?.response?.reportCode;
    },
    resetMsg: (state, action) => {
      if (action.payload === 'search') {
        state.reportCode = '';
        state.reportName = '';
        state.lastStep = 0;
      } else {
        state.successMsg = null;
        state.errorMsg = null;
        state.isLoading = false;
        state.addHeaderStatus = null;
        state.addFilterStatus = null;
        state.addFieldListStatus = null;
        state.getfilterData = {};
        // state.actionData = null
      }
    },
    resetReportFieldsStatus: (state) => {
      state.reportFieldsPostStatus = null;
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
    resetFilterData: (state, action) => {
      state.filterData = [];
      state.isLoading = false;
    },
    resetReportScheduleData: (state) => {
      state.ScheduleData = {};
    },
    resetReportMasterData: (state, action) => {
      state.reportMasterData = {};
      state.isLoading = false;
      state.basicInfoData = {};
      state.fieldlListData = {};
      state.getfilterData = {};
      state.additionalInfoData = {};
    },
    resetCopyReportData: (state, action) => {
      state.copyReportStatus = null;
      state.iscopyLoading = false;
      state.copySuccessMsg = null;
      state.copyErrorMsg = null;
    },
    resetCopyWorkQueueData: (state, action) => {
      state.copyWorkQueueStatus = null;
      state.iscopyLoading = false;
      state.copySuccessMsg = null;
      state.copyErrorMsg = null;
    },
    resetAdditionalInfoData: (state, action) => {
      state.addAdditionalInfoStatus = null;
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetWorkQueueData: (state, action) => {
      state.addWorkQueueStatus = null;
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },

    resetScheduleData: (state, action) => {
      state.addScheduleStatus = null;
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetReportFieldsData: (state) => {
      state.reportFieldsData = [];
      state.reportFieldsSortData = [];
      state.reportDateStampFields = [];
    },
    resetCreateReportData: (state) => {
      state.lastStep = 0;
    },
    resetExecutionData: (state) => {
      state.executionData = [];
    },
  },
});
export default addReportMaster.reducer;
export const {
  fetchStart,
  fetchError,
  resetMsg,
  postHeaderData,
  getReportMasterData,
  getReportFieldsData,
  getScheduleData,
  getFilterData,
  resetFilterData,
  postFilterData,
  postFieldListData,
  getBasicInfoData,
  getFieldListData,
  getAdditionalInfoData,
  getWorkQueueData,
  postScheduleData,
  getFilterDatas,
  resetReportMasterData,
  fetchCopy,
  postCopyReportData,
  resetCopyReportData,
  fetchCopyError,
  postReportFieldsData,
  postAdditionalInfoData,
  postWorkQueueData,
  getReportCodeData,
  resetReportFieldsData,
  getReportCreatedForData,
  resetReportFieldsStatus,
  setReduxState,
  resetAdditionalInfoData,
  resetWorkQueueData,
  resetScheduleData,
  getRunExecutionData,
  postCopyWorkQueueData,
  resetCopyWorkQueueData,
  resetCreateReportData,
  resetExecutionData,
  getCreatedByData,
  getCreatedForData,
  resetReportScheduleData,
  getWorkQueueNameData,
} = addReportMaster.actions;

export const postHeaderInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`reportstransaction/save/report/header`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postHeaderData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postFilter = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(submissionEnd());
    httpPost(`reportstransaction/save/reportrules`, _.omit(details, 'isTestClicked'))
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postFilterData(data));
          if (details?.isTestClicked) {
            dispatch(fetchFilter(data?.response?.reportId));
          }
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postFieldList = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`reportstransaction/save/report/fieldlistcode`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postFieldListData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postAdditionalInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(submissionEnd());
    httpPost(`reportstransaction/save/reportaddinfo`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postAdditionalInfoData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postAdditionalInfoWorkQueue = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`reportstransaction/save/workqueue`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postWorkQueueData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postScheduleDetails = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`schedule/save/report/schedule`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postScheduleData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postReportFieldsDetails = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(submissionEnd());
    httpPost(`reportstransaction/save/transactionreportfield`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postReportFieldsData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchFilterData = (fieldListCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/find/all/filtergroup/${fieldListCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getFilterData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchExecutionReportData = (reportCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`report/execution/findall/${reportCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getRunExecutionData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
// export const fetchReportMaster = (reportMasterId) => {
//   return (dispatch) => {
//     dispatch(fetchStart());
//     httpGet(`reportstransaction/get/report/${reportMasterId}`)
//       .then((data) => {
//         if (data && data.status && data.status === 200) {
//           dispatch(getReportMasterData(data.response));
//         } else {
//           dispatch(fetchError(data?.data?.error));
//         }
//       })
//       .catch((error) => {
//         dispatch(fetchError(error.message));
//       });
//   };
// };
export const fetchReportFields = (reportCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reportstransaction/get/reportfields/${reportCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getReportFieldsData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchSchedule = (reportCode, batchTriggers, frameworkScheduleId, tabType) => {
  // const URL = batchTriggers
  //   ? "schedule/find/batchtrigger/schedule"
  //   : "schedule/find/report/schedule";
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`schedule/find/report/schedule/${frameworkScheduleId}/${tabType}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getScheduleData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchFieldList = (reportCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reportstransaction/get/report/fieldlistcode/${reportCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getFieldListData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAdditionalInfo = (reportCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reportstransaction/find/report/${reportCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getAdditionalInfoData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchWorkQueue = (reportCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reportstransaction/get/workQueue/${reportCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getWorkQueueData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchBasicInfo = (reportCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reportstransaction/get/reportheader/${reportCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getBasicInfoData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchFilter = (reportCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reportstransaction/get/reportrules/${reportCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getFilterDatas(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postCopyReport = (details) => {
  return (dispatch) => {
    dispatch(fetchCopy());
    httpPost(`reportstransaction/save/copy/report`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCopyReportData(data));
        } else {
          dispatch(fetchCopyError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchCopyError(error.message));
      });
  };
};
export const postCopyWorkQueue = (details) => {
  return (dispatch) => {
    dispatch(fetchCopy());
    httpPost(`reportstransaction/save/copy/workQueue`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCopyWorkQueueData(data));
        } else {
          dispatch(fetchCopyError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchCopyError(error.message));
      });
  };
};
export const getAllReportCodeData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reportstransaction/find/all/reportcodeanddescription`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getReportCodeData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getAllWorkqueueNameData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reportstransaction/get/workqueue/name`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getWorkQueueNameData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getAllReportCreatedForData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`get/all/username`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          let dataReformed = [];
          dataReformed =
            data &&
            data?.response?.length > 0 &&
            data?.response?.map((i) => {
              return { userName: i?.userName, userLoginName: i?.userLoginName };
            });
          dispatch(getReportCreatedForData(dataReformed));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchCreatedByDropDownData = (type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`workqueuesetup/get/${type}/createdby`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getCreatedByData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchCreatedForDropDownData = (type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`searchcreatedby/get/${type}/createdfor`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getCreatedForData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const resetFilter = () => {
  return (dispatch) => {
    dispatch(resetFilterData());
  };
};
export const resetMessage = (page) => {
  return (dispatch) => {
    dispatch(resetMsg(page));
  };
};
export const resetReportFields = () => {
  return (dispatch) => {
    dispatch(resetReportFieldsStatus());
  };
};
export const resetReportMaster = () => {
  return (dispatch) => {
    dispatch(resetReportMasterData());
  };
};
export const resetCopyReport = () => {
  return (dispatch) => {
    dispatch(resetCopyReportData());
  };
};
export const resetCopyWorkQueue = () => {
  return (dispatch) => {
    dispatch(resetCopyWorkQueueData());
  };
};
export const resetAdditionalInfo = () => {
  return (dispatch) => {
    dispatch(resetAdditionalInfoData());
  };
};
export const resetWorkQueue = () => {
  return (dispatch) => {
    dispatch(resetWorkQueueData());
  };
};

export const resetSchedule = () => {
  return (dispatch) => {
    dispatch(resetScheduleData());
  };
};
export const resetExecution = () => {
  return (dispatch) => {
    dispatch(resetExecutionData());
  };
};
export const resetReportSchedule = () => {
  return (dispatch) => {
    dispatch(resetReportScheduleData());
  };
};
export const resetCreateReport = () => {
  return (dispatch) => {
    dispatch(resetCreateReportData());
  };
};
